import script from "./PaywallGuarantee.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallGuarantee.vue?vue&type=script&setup=true&lang=js"

import "./PaywallGuarantee.vue?vue&type=style&index=0&id=408f1e82&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408f1e82"]])

export default __exports__